import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  SimpleChanges,
  input,
  inject,
} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SubscriptionService } from '@fitness-force/api';
import type { SubscriptionById } from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { SkeletonModule } from 'primeng/skeleton';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';

export interface SubscriptionClient {
  clt_subs_id: number;
  id: number;
  full_name: string;
  company_id: number;
  tenant_id: number;
  plan_id: number;
  state: string;
  status: string;
  name_primary_language: string;
  name_secondary_language: string;
  start_date: string;
  end_date: string;
  next_charge_date: string;
  sign_up_date: string;
}

@Component({
  selector: 'subscription-clients',
  templateUrl: './subscription-clients.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TableModule,
    SkeletonModule,
    DateTimeFormatPipe,
    TranslateModule,
    AsyncPipe,
  ],
})
export class SubscriptionClientsComponent implements OnInit {
  translate = inject(TranslateService);
  private subscriptionService = inject(SubscriptionService);

  readonly subscription = input<SubscriptionById>();
  readonly clientId = input<number>(0);
  readonly tenantId = input<number>(0);

  subscriptionClients$ = new BehaviorSubject<SubscriptionClient[]>([]);
  showSkeleton: boolean = true;

  ngOnInit(): void {
    // this.loadSubscriptionClients();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['subscription'] && this.subscription()) {
      this.loadSubscriptionClients();
    }
  }

  loadSubscriptionClients() {
    const subscription = this.subscription();
    if (!subscription || !subscription.plan_id) {
      this.subscriptionClients$.next([]);
      this.showSkeleton = false;
      return;
    }

    this.showSkeleton = true;
    this.subscriptionService
      .getSubscriptionFamilyMenbers(this.tenantId(), subscription.plan_id)
      .subscribe({
        next: (response: any) => {
          if (response && response.items) {
            this.subscriptionClients$.next(
              response.items.filter((item: any) => item.id !== this.clientId()),
            );
          } else {
            this.subscriptionClients$.next([]);
          }
          this.showSkeleton = false;
        },
        error: (error) => {
          console.error('Error loading subscription clients:', error);
          this.subscriptionClients$.next([]);
          this.showSkeleton = false;
        },
      });
  }

  isParentSubscription(): boolean {
    const subscription = this.subscription();
    return !!(
      subscription &&
      subscription.family_owner_subs_id > 0 &&
      subscription.family_owner_subs_id === subscription.id
    );
  }

  isChildSubscription(): boolean {
    const subscription = this.subscription();
    return !!(
      subscription &&
      subscription.family_owner_client_id > 0 &&
      subscription.family_owner_subs_id !== subscription.id &&
      subscription.is_family_child === true
    );
  }
}
